declare var window: any;

const Filter = {
  // `this.hide` and `this.show` uses execJS to maintain added/remove attrs
  // even after LV update
  hide(element: HTMLElement) {
    window.liveSocket.execJS(
      element,
      // JS encoded from Phoenix.LiveView.JS `JS.add_class("hidden") |> JS.add_attribute({"aria-hidden", "true"})`
      '[["add_class",{"names":["hidden"],"time":200,"to":null,"transition":[[],[],[]]}],["set_attr",{"attr":["aria-hidden","true"],"to":null}]]',
    );
  },
  show(element: HTMLElement) {
    window.liveSocket.execJS(
      element,
      // JS encoded from Phoenix.LiveView.JS `JS.remove_class("hidden") |> JS.remove_attribute("aria-hidden")`
      '[["remove_class",{"names":["hidden"],"time":200,"to":null,"transition":[[],[],[]]}],["remove_attr",{"attr":"aria-hidden","to":null}]]',
    );
  },
  // Hide or show inputs based on whether the search term matches any labels within it
  renderInputs(this: any, searchTerm: string) {
    this.el
      .querySelectorAll("[data-filter-input]")
      .forEach((filterInput: HTMLElement) => {
        let contents: Array<string> = [];
        filterInput.querySelectorAll("label").forEach((el: any) => {
          contents.push(el.textContent);
        });

        if (
          contents.some((content: string) =>
            content.toLocaleLowerCase().includes(searchTerm.toLowerCase()),
          )
        ) {
          this.show(filterInput);
        } else {
          this.hide(filterInput);
        }
      });
  },
  // Hide accordion headings & body when all inputs are hidden, otherwise show
  renderAccordionItems(this: any) {
    this.el
      .querySelectorAll('[aria-labelledby*="collapse-heading"]')
      .forEach((accordionBody: any) => {
        let hiddenInputs: any = [];

        const accordionContainer: any = document.getElementById(
          accordionBody.getAttribute("data-container"),
        );

        accordionBody
          .querySelectorAll("[data-filter-input]")
          .forEach((filterInput: Element) => {
            hiddenInputs.push(filterInput.getAttribute("aria-hidden"));
          });

        if (hiddenInputs.every((el: any) => el === "true")) {
          this.hide(accordionContainer);
        } else {
          this.show(accordionContainer);
        }
      });
  },
  updateFilterCount(this: any) {
    const filterCounter: any = document.querySelector("[data-filter-count]");
    const filterCount = this.el.querySelectorAll("[data-filter-active]").length;
    if (!filterCounter) {
      return;
    }

    if (filterCount > 0) {
      filterCounter.textContent = filterCount;
      filterCounter.style.display = "block";
    } else {
      filterCounter.textContent = "";
      filterCounter.style.display = "none";
    }
  },
  mounted(this: any) {
    this.handleEvent("search", (data: { term: string }) => {
      this.renderInputs(data.term);
      this.renderAccordionItems();
    });
    this.updateFilterCount();
  },
  updated(this: any) {
    this.updateFilterCount();
  },
};

export default Filter;
